export enum SupplierCustomerType {
  Festival = 'Festival',
  Corporate = 'Corporate',
  Private = 'Private'
}
